import { createSlice } from "@reduxjs/toolkit";

const youtubeIntial = {
    categories: [],
    category: '',
    query: '',
    thisSidebar: false,
}

const youtubeSlice = createSlice({
    name: "youtube",
    initialState: youtubeIntial,
    reducers: {
        setCategory: (state, action) => {
            state.category = ''
            state.category = action.payload
        },
        setCategories: (state, action) => {
            state.categories = action.payload
        },
        searchQuery: (state, action) => {
            state.query = action.payload
        },
        setThisSidebar: (state, action) => {
            state.thisSidebar = action.payload
        }
    }
})

export const { setCategory, setCategories, searchQuery, setThisSidebar } = youtubeSlice.actions;

export const youtubeReducer = youtubeSlice.reducer